import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_10 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SelectPicker/index.vue';
import __unplugin_components_9 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyCheckBox.vue';
import __unplugin_components_8 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/FileUpload.vue';
import __unplugin_components_7 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScanCell.vue';
import __unplugin_components_6 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/PositionCell.vue';
import __unplugin_components_5 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ImgUpload.vue';
import __unplugin_components_4 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyXAddress.vue';
import __unplugin_components_3 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/PopupCheckList.vue';
import __unplugin_components_2 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/DatetimeRange.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "custom-form"
  }, [_c('div', [_c('WriteExecute', {
    ref: "WriteExecute",
    on: {
      "on-success": _vm.callbackSign
    },
    model: {
      value: _vm.writeShow,
      callback: function ($$v) {
        _vm.writeShow = $$v;
      },
      expression: "writeShow"
    }
  })], 1), _vm._l(_vm.list, function (item, index) {
    return [item.type === 19 ? _c('group', {
      key: item.id
    }, [_c('Cell', {
      attrs: {
        "title": item.name,
        "value": _vm.calcValue(item)
      }
    })], 1) : _vm._e(), item.type === 20 ? _c('group', {
      key: item.id
    }, [_c('x-input', {
      attrs: {
        "title": i18n.tc("369"),
        "placeholder": i18n.tc("239"),
        "show-clear": true
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("167")) + " ")])])], 1) : _vm._e(), item.type === 21 ? _c('group', {
      key: item.id
    }, [_c('Cell', {
      attrs: {
        "title": i18n.tc("370"),
        "link": "",
        "value": item.tfvvalue ? i18n.tc("322") : i18n.tc("371")
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.handleSign(item, index);
        }
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("370")) + " ")])]), _c('div', {
      staticClass: "signature font-size-h3-large",
      on: {
        "click": function ($event) {
          return _vm.handleSign(item, index);
        }
      }
    }, [!item.tfvvalue ? [_vm._v(i18n.tc("323"))] : _c('img', {
      attrs: {
        "src": item.tfvvalue
      }
    })], 2)], 1) : _vm._e(), item.type === 22 ? _c('group', {
      key: item.id
    }, [_c('Cell', {
      attrs: {
        "title": item.name
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("20")) + " ")]), _c('Rater', {
      attrs: {
        "value": Number(item.tfvvalue) || 0,
        "active-color": "#ffb84d",
        "margin": 5,
        "font-size": 20
      },
      on: {
        "input": function ($event) {
          item.tfvvalue = $event;
        }
      }
    })], 1)], 1) : _vm._e(), item.type === 23 ? _c(__unplugin_components_0, {
      key: item.id,
      attrs: {
        "labelWidth": _vm.labelWidth,
        "format": "YYYY-MM-DD",
        "name": item.name,
        "required": item.is_required
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }) : _vm._e(), item.type === 24 ? _c(__unplugin_components_1, {
      key: item.id,
      attrs: {
        "labelWidth": _vm.labelWidth,
        "format": "HH:mm",
        "name": item.name,
        "required": item.is_required
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }) : _vm._e(), item.type === 25 ? _c(__unplugin_components_2, {
      key: item.id,
      attrs: {
        "labelWidth": _vm.labelWidth,
        "format": "YYYY-MM-DD HH:mm",
        "name": item.name,
        "required": item.is_required
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }) : _vm._e(), item.type === 1 ? _c('group', {
      key: item.id
    }, [_c('XTextarea', {
      attrs: {
        "title": i18n.tc("369"),
        "placeholder": i18n.tc("239"),
        "autosize": true,
        "show-counter": false,
        "rows": 1
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("372")) + " ")])])], 1) : _vm._e(), item.type === 2 ? _c('group', {
      key: item.id
    }, [_c('x-input', {
      attrs: {
        "title": i18n.tc("373"),
        "type": "text",
        "placeholder": i18n.tc("374"),
        "is-type": _vm.numberValidate,
        "show-clear": true
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("373")) + " ")])])], 1) : _vm._e(), item.type === 3 ? _c('group', {
      key: item.id
    }, [_c('popup-picker', {
      attrs: {
        "show-name": "",
        "title": i18n.tc("375"),
        "placeholder": i18n.tc("237"),
        "value-text-align": "right",
        "columns": 1,
        "data": item.dropList,
        "value": [item.ovalue]
      },
      on: {
        "on-show": _vm.pickerFcous,
        "on-change": function ($event) {
          item.ovalue = $event.join(',');
        }
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("376")) + " ")])])], 1) : _vm._e(), item.type === 4 ? _c('group', {
      key: item.id
    }, [_c('datetime', {
      attrs: {
        "format": "YYYY-MM-DD",
        "placeholder": i18n.tc("237")
      },
      on: {
        "on-show": _vm.pickerFcous
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("377")) + " ")])])], 1) : _vm._e(), item.type === 5 ? _c('group', {
      key: item.id
    }, [_c('datetime', {
      attrs: {
        "format": "HH:mm",
        "placeholder": i18n.tc("237")
      },
      on: {
        "on-show": _vm.pickerFcous
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("292")) + " ")])])], 1) : _vm._e(), item.type === 6 ? _c('group', {
      key: item.id
    }, [_c('datetime', {
      attrs: {
        "format": "YYYY-MM-DD HH:mm",
        "placeholder": i18n.tc("237")
      },
      on: {
        "on-show": _vm.pickerFcous
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("378")) + " ")])])], 1) : _vm._e(), item.type === 7 ? _c('group', {
      key: item.id
    }, [_c('x-switch', {
      attrs: {
        "title": item.name,
        "value-map": [0, 1]
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    })], 1) : _vm._e(), item.type === 8 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_3, {
      attrs: {
        "show-name": "",
        "value-text-align": "right",
        "placeholder": i18n.tc("237"),
        "title": item.name,
        "data": item.dropList
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("379")) + " ")])])], 1) : _vm._e(), item.type === 9 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_4, {
      attrs: {
        "placeholder": i18n.tc("237")
      },
      on: {
        "on-change": function (ids, names) {
          return _vm.xAddressOnChange(item, ids, names);
        }
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("380")) + " ")])])], 1) : _vm._e(), item.type === 10 || item.type === 26 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_5, {
      attrs: {
        "hidden-border": "",
        "waterMask": _vm.getWaterMask(item)
      },
      on: {
        "on-change": function ($event) {
          item.tfvvalue = $event.join(',');
        }
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("381")) + " ")])])], 1) : _vm._e(), item.type === 11 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_6, {
      attrs: {
        "placeholder": i18n.tc("382"),
        "address": item.tfvvalue.split(',')
      },
      on: {
        "on-change": function (pos, addr) {
          return item.tfvvalue = addr + "," + addr + "," + pos.join(',');
        }
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("100")) + " ")])])], 1) : _vm._e(), item.type === 12 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_7, {
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("100")) + " ")])])], 1) : _vm._e(), item.type === 13 ? _c('group', {
      key: item.id
    }, [_c('x-textarea', {
      staticClass: "smy__textarea",
      attrs: {
        "show-counter": "",
        "name": "detail",
        "placeholder": i18n.tc("239"),
        "max": 500
      },
      model: {
        value: item.tfvvalue,
        callback: function ($$v) {
          _vm.$set(item, "tfvvalue", $$v);
        },
        expression: "item.tfvvalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("383")) + " ")])])], 1) : item.type === 14 ? _c('div', {
      key: item.id
    }, [_c('div', {
      staticClass: "instruction-com font-size-h3-large"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      staticClass: "item-bubble-img instruction-img"
    }, [_c('photo-provider', _vm._l(item.fieldAttributeList || [], function (image, i) {
      return _c('photo-consumer', {
        key: i,
        attrs: {
          "intro": _vm.$showName(image.value),
          "src": image.value
        }
      }, [_c('img', {
        staticClass: "previewer-demo-img item-bubble-img-i",
        attrs: {
          "src": image.value
        }
      })]);
    }), 1)], 1)]) : _vm._e(), item.type === 15 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_8, {
      attrs: {
        "hidden-border": ""
      },
      on: {
        "on-change": function ($event) {
          item.tfvvalue = $event.join(',');
        }
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    }, [_c('div', {
      style: {
        position: 'relative',
        width: _vm.labelWidth + 'px'
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [item.is_required && item.is_required === 1 ? _c('span', {
      staticClass: "form-red-star"
    }, [_vm._v("*")]) : _vm._e(), _vm._v(" " + _vm._s(item.name || i18n.tc("384")) + " ")])])], 1) : _vm._e(), item.type === 16 ? _c('group', {
      key: item.id
    }, [_c(__unplugin_components_9, {
      attrs: {
        "title": item.name,
        "value-map": [0, 1]
      },
      model: {
        value: item.ovalue,
        callback: function ($$v) {
          _vm.$set(item, "ovalue", $$v);
        },
        expression: "item.ovalue"
      }
    })], 1) : _vm._e(), item.type === 17 ? _c('group', {
      key: item.id
    }, [_c('a', {
      attrs: {
        "href": _vm.spliteHyperLink(item.name)[0],
        "target": "_blank"
      }
    }, [_c('Cell', {
      staticClass: "main-color",
      attrs: {
        "title": _vm.spliteHyperLink(item.name)[1],
        "is-link": ""
      }
    })], 1)]) : _vm._e(), item.type === 18 ? _c('group', {
      key: item.id
    }, [_c('Cell', {
      attrs: {
        "title": item.name,
        "value": item._name,
        "is-link": ""
      },
      nativeOn: {
        "click": function ($event) {
          item._isShow = true;
        }
      }
    }), _c(__unplugin_components_10, {
      attrs: {
        "list": item.dropList,
        "data": item.arrvalue
      },
      on: {
        "on-change": function (e) {
          return item.ovalue = e;
        },
        "on-change-name": function ($event) {
          item._name = $event;
        }
      },
      model: {
        value: item._isShow,
        callback: function ($$v) {
          _vm.$set(item, "_isShow", $$v);
        },
        expression: "item._isShow"
      }
    })], 1) : _vm._e()];
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };